 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		72: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		72: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/js/" + ({"0":"Aika","1":"Aikamuunnin","2":"AlvLaskuri","3":"AlvTunnuksenTarkistaja","4":"AsteRadiaaniMuunnin","5":"BbanIbanMuunnin","6":"BicSelvitin","7":"Chart-Chart","8":"Chart-ValtionvelkaChart","9":"Etaisyyslaskuri","10":"JosOlisinSijoittanutKryptovaluuttaan","11":"Kannykanhinta","12":"Kellonaikalaskuri","13":"KellyPanostusLaskuri","14":"Kerroinmuunnin","15":"Kertotaulut","16":"Keskiarvolaskuri","17":"KorkoaKorolleLaskuri","18":"Korkolaskuri","19":"KotitaloudenTuloJaMenoLaskuri","20":"Lampomuunnin","21":"Laskin2","22":"LierionTilavuusLaskuri","23":"MD5Muunnin","24":"MatemaattisetVakiot","25":"NPSLaskuri","26":"Nopeusmuunnin","27":"Painoindeksilaskuri","28":"Painomuunnin","29":"Paivalaskuri","30":"PallonTilavuusLaskuri","31":"Peruslaskutoimitukset","32":"Pituusmuunnin","33":"Polttoainelaskuri","34":"Prosenttilaskuri","35":"Pvmroomalaisinnumeroin","36":"Rahanarvomuunnin","37":"RoomalaisetNumerotMuunnin","38":"SHA1Muunnin","39":"SahkoPolttomoottoriVertailu","40":"SahkonHintaNyt","41":"Sahkonhintalaskuri","42":"Sanageneraattori","43":"Sanalaskuri","44":"Satunnaislukugeneraattori","45":"Sekuntikello","46":"SwatchInternetTime","47":"Syntymapaivalaskuri","48":"Taksalaskuri","49":"Tilavuusmuunnin","50":"Tuntihintalaskuri","51":"UnixAika","52":"Valtionvelkalaskuri","53":"Valuuttamuunnin","54":"Viikonpaivalaskin","55":"Viitenumerolaskuri","56":"Virtuaaliviivakoodigeneraattori","57":"Wordle","58":"YTunnuksenTarkistaja","59":"YmpyranPintaAlaLaskuri","60":"calculator-LaskinUusi","61":"calculator-btnConfig","62":"utils-Beautify","63":"utils-GetDayName","64":"utils-Holidays","65":"utils-InRange","66":"utils-MarketChartDevelopment","67":"utils-ReplaceDots","68":"calculator-calculator-css","69":"canvg","71":"pdfmake","73":"xlsx"}[chunkId]||chunkId) + "." + {"0":"fac70b29","1":"19dcab7f","2":"21ced8ad","3":"53a8eaf9","4":"9a1164fe","5":"31766c57","6":"cd401baa","7":"d06894b6","8":"0cd9158e","9":"488740f3","10":"6bcc4761","11":"e790c1c1","12":"4609a6d9","13":"e839a4b5","14":"dcb1be26","15":"ea8a77e5","16":"f645078e","17":"f56ed2bd","18":"b29ee9c9","19":"000b533c","20":"ae8ec33b","21":"78e4f3ec","22":"05a0e39b","23":"fbe984a5","24":"e8c8938e","25":"c55460ac","26":"0b09eda5","27":"dfad7cd0","28":"98e606ae","29":"ab17cf0c","30":"84bb9da7","31":"54777ddc","32":"8b1ef40f","33":"48afed5f","34":"2ba5871d","35":"8fd4ebc0","36":"0c63f23d","37":"03252943","38":"b47c4660","39":"e7ba20b0","40":"83f0caf4","41":"f575d892","42":"be4e8f7f","43":"0a69b0f3","44":"18c2d1b6","45":"c656760d","46":"c30a164c","47":"25190f11","48":"155e5220","49":"7c73ae4a","50":"0058ce2a","51":"6870cb23","52":"5eb85a4c","53":"051aa3a0","54":"ff3e88dc","55":"310013a3","56":"30b812c7","57":"343154d9","58":"89f65f74","59":"54b97729","60":"1ce26cc4","61":"b7013dbb","62":"8b61f132","63":"d3982aee","64":"40ef2f50","65":"0b214fc1","66":"61c9b946","67":"a7f4d532","68":"5342f9e1","69":"dcb20d6f","71":"38a957d5","73":"293a0c77"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"60":1,"68":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + ({"0":"Aika","1":"Aikamuunnin","2":"AlvLaskuri","3":"AlvTunnuksenTarkistaja","4":"AsteRadiaaniMuunnin","5":"BbanIbanMuunnin","6":"BicSelvitin","7":"Chart-Chart","8":"Chart-ValtionvelkaChart","9":"Etaisyyslaskuri","10":"JosOlisinSijoittanutKryptovaluuttaan","11":"Kannykanhinta","12":"Kellonaikalaskuri","13":"KellyPanostusLaskuri","14":"Kerroinmuunnin","15":"Kertotaulut","16":"Keskiarvolaskuri","17":"KorkoaKorolleLaskuri","18":"Korkolaskuri","19":"KotitaloudenTuloJaMenoLaskuri","20":"Lampomuunnin","21":"Laskin2","22":"LierionTilavuusLaskuri","23":"MD5Muunnin","24":"MatemaattisetVakiot","25":"NPSLaskuri","26":"Nopeusmuunnin","27":"Painoindeksilaskuri","28":"Painomuunnin","29":"Paivalaskuri","30":"PallonTilavuusLaskuri","31":"Peruslaskutoimitukset","32":"Pituusmuunnin","33":"Polttoainelaskuri","34":"Prosenttilaskuri","35":"Pvmroomalaisinnumeroin","36":"Rahanarvomuunnin","37":"RoomalaisetNumerotMuunnin","38":"SHA1Muunnin","39":"SahkoPolttomoottoriVertailu","40":"SahkonHintaNyt","41":"Sahkonhintalaskuri","42":"Sanageneraattori","43":"Sanalaskuri","44":"Satunnaislukugeneraattori","45":"Sekuntikello","46":"SwatchInternetTime","47":"Syntymapaivalaskuri","48":"Taksalaskuri","49":"Tilavuusmuunnin","50":"Tuntihintalaskuri","51":"UnixAika","52":"Valtionvelkalaskuri","53":"Valuuttamuunnin","54":"Viikonpaivalaskin","55":"Viitenumerolaskuri","56":"Virtuaaliviivakoodigeneraattori","57":"Wordle","58":"YTunnuksenTarkistaja","59":"YmpyranPintaAlaLaskuri","60":"calculator-LaskinUusi","61":"calculator-btnConfig","62":"utils-Beautify","63":"utils-GetDayName","64":"utils-Holidays","65":"utils-InRange","66":"utils-MarketChartDevelopment","67":"utils-ReplaceDots","68":"calculator-calculator-css","69":"canvg","71":"pdfmake","73":"xlsx"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0","1":"31d6cfe0","2":"31d6cfe0","3":"31d6cfe0","4":"31d6cfe0","5":"31d6cfe0","6":"31d6cfe0","7":"31d6cfe0","8":"31d6cfe0","9":"31d6cfe0","10":"31d6cfe0","11":"31d6cfe0","12":"31d6cfe0","13":"31d6cfe0","14":"31d6cfe0","15":"31d6cfe0","16":"31d6cfe0","17":"31d6cfe0","18":"31d6cfe0","19":"31d6cfe0","20":"31d6cfe0","21":"31d6cfe0","22":"31d6cfe0","23":"31d6cfe0","24":"31d6cfe0","25":"31d6cfe0","26":"31d6cfe0","27":"31d6cfe0","28":"31d6cfe0","29":"31d6cfe0","30":"31d6cfe0","31":"31d6cfe0","32":"31d6cfe0","33":"31d6cfe0","34":"31d6cfe0","35":"31d6cfe0","36":"31d6cfe0","37":"31d6cfe0","38":"31d6cfe0","39":"31d6cfe0","40":"31d6cfe0","41":"31d6cfe0","42":"31d6cfe0","43":"31d6cfe0","44":"31d6cfe0","45":"31d6cfe0","46":"31d6cfe0","47":"31d6cfe0","48":"31d6cfe0","49":"31d6cfe0","50":"31d6cfe0","51":"31d6cfe0","52":"31d6cfe0","53":"31d6cfe0","54":"31d6cfe0","55":"31d6cfe0","56":"31d6cfe0","57":"31d6cfe0","58":"31d6cfe0","59":"31d6cfe0","60":"15a0c375","61":"31d6cfe0","62":"31d6cfe0","63":"31d6cfe0","64":"31d6cfe0","65":"31d6cfe0","66":"31d6cfe0","67":"31d6cfe0","68":"15a0c375","69":"31d6cfe0","71":"31d6cfe0","73":"31d6cfe0"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/wp-content/plugins/react-wordpress/widget/build/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonplaskurit_frontend"] = this["webpackJsonplaskurit_frontend"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
